import './Login.scss';

import { Button, Form, Input, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import useLogin from '@/Apis/hooks/mutations/useLogin/useLogin';
import { Controller, useForm } from 'react-hook-form';
import { LoginForm } from './types';
import { yupResolver } from '@hookform/resolvers/yup';
import validation from './validation';
import { useAppDispatch } from '@/Store/Store';
import { setToken } from '@/Store/Modules/User';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const Login = () => {
	const { control, handleSubmit } = useForm<LoginForm>({
		resolver: yupResolver(validation),
	});

	const navigate = useNavigate();

	const dispatch = useAppDispatch();

	const { mutate: login, isLoading } = useLogin();

	const handleLogin = (data: LoginForm) => {
		login(data, {
			onSuccess: (data) => {
				if (data.status === 0 && data.data.token) {
					localStorage.setItem('token', data.data.token);
					dispatch(setToken(data.data.token));
					navigate('/');
				}
			},
		});
	};

	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			navigate('/');
		}
	}, [navigate]);

	return (
		<div className='login-page'>
			<div className='form-container'>
				<div className='form-title'>
					<Typography.Title>Tuntun LCMP</Typography.Title>
					<Typography.Text>
						Please login using your username and password.
					</Typography.Text>
				</div>

				<Form
					className='login-form'
					name='login'
					onFinish={handleSubmit(handleLogin)}
				>
					<Controller
						control={control}
						name='account'
						render={({ field, fieldState: { error } }) => (
							<Form.Item
								validateStatus={error?.message ? 'error' : 'success'}
								help={error?.message}
							>
								<Input
									size='large'
									prefix={<UserOutlined className='site-form-item-icon' />}
									placeholder='Username'
									onChange={field.onChange}
								/>
							</Form.Item>
						)}
					/>

					<Controller
						control={control}
						name='password'
						render={({ field, fieldState: { error } }) => (
							<Form.Item
								validateStatus={error?.message ? 'error' : 'success'}
								help={error?.message}
							>
								<Input
									size='large'
									prefix={<LockOutlined className='site-form-item-icon' />}
									type='password'
									placeholder='Password'
									onChange={field.onChange}
								/>
							</Form.Item>
						)}
					/>

					<Button
						size='large'
						type='primary'
						htmlType='submit'
						className='login-form-button'
						style={{ width: '100%', marginTop: 12 }}
						loading={isLoading}
					>
						Log in
					</Button>
				</Form>
			</div>
		</div>
	);
};

export default Login;
